import logo from './logo.svg';
import './App.css';
import * as React from 'react';
import { useState } from 'react';

// Components
import Button from '@mui/joy/Button';
import List from '@mui/joy/List';
import ListSubheader from '@mui/joy/ListSubheader';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListItemContent from '@mui/joy/ListItemContent';
import IconButton from '@mui/joy/IconButton';
import Input from '@mui/joy/Input';
import Card from '@mui/joy/Card';
import CardCover from '@mui/joy/CardCover';
import CardContent from '@mui/joy/CardContent';
import Box from '@mui/joy/Box';
import Divider from '@mui/joy/Divider';
import Grid from '@mui/joy/Grid';
import Typography from '@mui/joy/Typography';
import { CssVarsProvider, useColorScheme } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';

import Sheet from '@mui/joy/Sheet';
import Avatar from '@mui/joy/Avatar';
import CardOverflow from '@mui/joy/CardOverflow';
import AvatarGroup from '@mui/joy/AvatarGroup';
import { AspectRatio } from '@mui/icons-material';

import FolderOpenIcon from '@mui/icons-material/FolderOpen';

// Custom
import Layout from '../src/components/Layout.tsx';
import teamTheme from '../src/theme.tsx';
import Menu from '../src/components/Menu.tsx';

// Icons
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import HotelIcon from '@mui/icons-material/Hotel';
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import HotTubIcon from '@mui/icons-material/HotTub';
import ParkIcon from '@mui/icons-material/Park';
import CityIcon from '@mui/icons-material/Apartment';
import VillaIcon from '@mui/icons-material/Villa';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import HouseboatIcon from '@mui/icons-material/Houseboat';
import PoolIcon from '@mui/icons-material/Pool';
import CabinIcon from '@mui/icons-material/Cabin';
import CasinoIcon from '@mui/icons-material/Casino';
import CastleIcon from '@mui/icons-material/Castle';
import DownhillSkiingIcon from '@mui/icons-material/DownhillSkiing';
import FireIcon from '@mui/icons-material/LocalFireDepartment';
import FestivalIcon from '@mui/icons-material/Festival';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import SnowflakeIcon from '@mui/icons-material/AcUnit';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import CelebrationIcon from '@mui/icons-material/Celebration';
import ChurchIcon from '@mui/icons-material/Church';
import DiscountIcon from '@mui/icons-material/Discount';
import AccessibleIcon from '@mui/icons-material/Accessible';

function VerticalNavbar() {
  return (
    <List size='sm' sx={{ '--ListItem-radius': '8px', '--List-gap': '4px' }}>
      <ListItem nested>
        <ListSubheader>
          Browse
          <IconButton
            size='sm'
            variant='plain'
            color='primary'
            sx={{
              '--IconButton-size': '24px',
              ml: 'auto',
              '@media (max-width: 600px)': {
                width: '300px', // width when screen is less than 600px
                display: 'none', // hide when screen is less than 600px
              },
            }}
          >
          </IconButton>
        </ListSubheader>
        <List
          aria-labelledby='nav-list-browse'
          sx={{
            '& .JoyListItemButton-root': { p: '8px' },
          }}
        >
          <ListItemButton variant='soft' color='primary'>
            <ListItemDecorator sx={{ color: 'inherit' }}>
              <FireIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Trending</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <DiscountIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Discounted</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <HotTubIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Hot Tubs</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <ParkIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>National Parks</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <CityIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>City</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <VillaIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Villa</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <HolidayVillageIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Holiday Village</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <TravelExploreIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Remote</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <HouseboatIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>House Boat</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <PoolIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Pool</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <CabinIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Cabin</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <BeachAccessIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Beach</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <CasinoIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Casino</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <CelebrationIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Party</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <CastleIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Castle</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <CabinIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Cabin</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <DownhillSkiingIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Skiing</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <FestivalIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Festival</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <RestaurantIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Bed and Breakfeast</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <SnowflakeIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Artic</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <GolfCourseIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Golf Course</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <ChurchIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Church</ListItemContent>
          </ListItemButton>

          <ListItemButton>
            <ListItemDecorator sx={{ color: 'neutral.500' }}>
              <AccessibleIcon fontSize='small' />
            </ListItemDecorator>
            <ListItemContent>Accessible</ListItemContent>
          </ListItemButton>

        </List>
      </ListItem>
    </List>
  );
}

// function GridItem({ name, imageUrl, locationText, price }) {
//   return (
//     <Sheet
//       variant='outlined'
//       sx={{
//         borderRadius: 'sm',
//         gridTemplateColumns: '1fr 1fr 1fr 1fr',
//         '& > *': {
//           p: 1.5,
//           '&:nth-child(n):not(:nth-last-child(-n+4))': {
//             borderBottom: '1px solid',
//             borderColor: 'divider',
//           },
//         },
//       }}>
//       <Card sx={{ minHeight: '280px', width: 320 }}>
//         <CardCover>
//           <img
//             src={imageUrl}
//             srcSet={`${imageUrl}?auto=format&fit=crop&w=320&dpr=2 2x`}
//             loading='lazy'
//             alt={name}
//           />
//         </CardCover>
//         <CardCover
//           sx={{
//             background:
//               'linear-gradient(to top, rgba(0,0,0,0.4), rgba(0,0,0,0) 200px), linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0) 300px)',
//           }}
//         />
//         <CardContent sx={{ justifyContent: 'flex-end' }}>
//           <Typography level='h2' fontSize='lg' textColor='#fff' mb={1}>
//             {name}
//           </Typography>
//           <Typography startDecorator={<LocationOnIcon />} textColor='neutral.300'>
//             {locationText}
//           </Typography>
//         </CardContent>
//       </Card>
//       <Typography level='h6'>${price} total</Typography>
//     </Sheet>
//   );
// }

function GridItem({ name, imageUrl, locationText, price }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Sheet
      variant='outlined'
      sx={{
        borderRadius: 'sm',
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        '& > *': {
          p: 1.5,
          '&:nth-child(n):not(:nth-last-child(-n+4))': {
            borderBottom: '1px solid',
            borderColor: 'divider',
          },
        },
      }}>
      <Card
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        sx={{ minHeight: '280px', width: 320, overflow: 'hidden' }}
      >
        <CardCover>
          <img
            src={imageUrl}
            srcSet={`${imageUrl}?auto=format&fit=crop&w=320&dpr=2 2x`}
            loading='lazy'
            alt={name}
            style={{
              transform: isHovered ? 'scale(1.05)' : 'scale(1)',
              transition: 'transform 0.3s ease-out',
            }}
          />
        </CardCover>
        <CardCover
          sx={{
            background:
              'linear-gradient(to top, rgba(0,0,0,0.4), rgba(0,0,0,0) 200px), linear-gradient(to top, rgba(0,0,0,0.8), rgba(0,0,0,0) 300px)',
          }}
        />
        <CardContent sx={{ justifyContent: 'flex-end' }}>
          <Typography level='h2' fontSize='lg' textColor='#fff' mb={1}>
            {name}
          </Typography>
          <Typography startDecorator={<LocationOnIcon />} textColor='neutral.300'>
            {locationText}
          </Typography>
        </CardContent>
      </Card>
      <Typography level='h6'>${price} total</Typography>
    </Sheet>
  );
}


function ViewGrid() {
  return (
  <Grid
    container
    spacing={{ xs: 2, md: 3 }}
    columns={{ xs: 4, sm: 8, md: 12 }}
    sx={{ flexGrow: 1 }}
    justifyContent='center'
    gap={2}
    maxHeight={300}
  >

  <GridItem
    name='BLU 5'
    imageUrl='https://blu-guest-house.allcycladeshotels.com/data/Photos/OriginalPhoto/11308/1130806/1130806683/blu-guest-house-adamantas-milos-photo-4.JPEG'
    locationText='Adamantas, Greece'
    price='5979'
  />

  <GridItem
    name='Cave House'
    imageUrl='https://cf.bstatic.com/xdata/images/hotel/max1024x768/260837048.jpg?k=ec0ca216f75a379a8ef151c3c7ecab15db44acd0e1d624e0cda16ba7f7b13b6a&o=&hp=1'
    locationText='South Aegean, Greece'
    price='1880'
  />

  <GridItem
    name='Le MICA'
    imageUrl='https://assets.hgtv.ca/wp-content/uploads/2023/02/Le-MICA-Slide-2.jpg'
    locationText='Quebec, Canada'
    price='2043'
  />

  <GridItem
    name="Black's Hut"
    imageUrl='https://black-beauty-hilltop-paradise-christchurch.booked.net/data/Photos/OriginalPhoto/8269/826937/826937126/Black-Beauty-Hilltop-Paradise-House-Apartment-Christchurch-Exterior.JPEG'
    locationText='Southland, New Zealand'
    price='1663'
  />

  <GridItem
    name='Indio Hills'
    imageUrl='https://www.luxury-architecture.net/wp-content/uploads/2018/05/37-Del-Mar-Newport-Coast-California_13.jpg'
    locationText='California, United States'
    price='3657'
  />

  <GridItem
    name='Portuzelo Castle'
    imageUrl='https://hostunusual.com/wp-content/uploads/2022/04/santa-marta-castle-main.jpg'
    locationText='Viana do Castelo, Portugal'
    price='6590'
  />

  <GridItem
    name='Lake Como Lights'
    imageUrl='https://castadiva-resort-spa-como.hotelmix.co.uk/data/Photos/OriginalPhoto/10323/1032305/1032305860/Mandarin-Oriental-Lago-Di-Como-Hotel-Blevio-Exterior.JPEG'
    locationText='Blevio, Italy'
    price='2800'
  />

  <GridItem
    name='Villa De Lago'
    imageUrl='https://www.thefinestretreats.com/images/US/Nevada/VilladeLago/1.jpg'
    locationText='Nevada, US'
    price='1950'
  />

  <GridItem
    name='Tielt'
    imageUrl='https://cf.bstatic.com/xdata/images/hotel/max500/382676359.jpg?k=f9ece1101db0332a7fdde753db0283620024ee4cdbd3a97f68fc577069de3ddf&o='
    locationText='Vlaanderen, Belgium'
    price='1086'
  />

  <GridItem
    name='Antoine Villa'
    imageUrl='https://cdt14.media.tourinsoft.eu/upload/le-traspy-thury-harcourt.jpg?width=750&height=520&crop=1'
    locationText='Vauville, France'
    price='11203'
  />

  <GridItem
    name='La Vida'
    imageUrl='https://cf.bstatic.com/xdata/images/hotel/max1024x768/299344194.jpg?k=90084c6811759baf0b88e83052d12a49db18abca01f1a93f61561cbb0a95f324&o=&hp=1'
    locationText='Murter, Croatia'
    price='2074'
  />

  <GridItem
    name='Aura House'
    imageUrl='https://www.rarestays.com/assets/img/c/large/v6qQEI8ryxqPPSLv.jpg'
    locationText='Bali, Indonesia'
    price='3045'
  />

  <GridItem
    name='Asi villa'
    imageUrl='https://cf.bstatic.com/xdata/images/hotel/max1024x768/226499282.jpg?k=f835db1fbfeeeedb615a1f5c2a0bde4d9ca51ff50c2fdf6405bd2f792a2fa5a3&o=&hp=1'
    locationText='Surattani, Thailand'
    price='5294'
  />

  <GridItem
    name='The Jade House'
    imageUrl='https://crlre.com/wp-content/uploads/1-Jade-House-Updated.png'
    locationText='Dominical, Costa Rica'
    price='5294'
  />  

  <GridItem
    name='Bora Bora One'
    imageUrl='https://cdn.britannica.com/57/99557-050-213502D2/Hut-dwellings-Bora-Bora-Society-Islands-French-Polynesia.jpg'
    locationText='Leeward Islands, French Polynesia'
    price='79653'
  />    

  <GridItem
      name='BLU 5'
      imageUrl='https://blu-guest-house.allcycladeshotels.com/data/Photos/OriginalPhoto/11308/1130806/1130806683/blu-guest-house-adamantas-milos-photo-4.JPEG'
      locationText='Adamantas, Greece'
      price='5979'
    />

    <GridItem
      name='Cave House'
      imageUrl='https://cf.bstatic.com/xdata/images/hotel/max1024x768/260837048.jpg?k=ec0ca216f75a379a8ef151c3c7ecab15db44acd0e1d624e0cda16ba7f7b13b6a&o=&hp=1'
      locationText='South Aegean, Greece'
      price='1880'
    />

    <GridItem
      name='Le MICA'
      imageUrl='https://assets.hgtv.ca/wp-content/uploads/2023/02/Le-MICA-Slide-2.jpg'
      locationText='Quebec, Canada'
      price='2043'
    />

<GridItem
    name="Black's Hut"
    imageUrl='https://black-beauty-hilltop-paradise-christchurch.booked.net/data/Photos/OriginalPhoto/8269/826937/826937126/Black-Beauty-Hilltop-Paradise-House-Apartment-Christchurch-Exterior.JPEG'
    locationText='Southland, New Zealand'
    price='1663'
  />

  <GridItem
    name='Indio Hills'
    imageUrl='https://www.luxury-architecture.net/wp-content/uploads/2018/05/37-Del-Mar-Newport-Coast-California_13.jpg'
    locationText='California, United States'
    price='3657'
  />

  <GridItem
    name='Portuzelo Castle'
    imageUrl='https://hostunusual.com/wp-content/uploads/2022/04/santa-marta-castle-main.jpg'
    locationText='Viana do Castelo, Portugal'
    price='6590'
  />

  <GridItem
    name='Lake Como Lights'
    imageUrl='https://castadiva-resort-spa-como.hotelmix.co.uk/data/Photos/OriginalPhoto/10323/1032305/1032305860/Mandarin-Oriental-Lago-Di-Como-Hotel-Blevio-Exterior.JPEG'
    locationText='Blevio, Italy'
    price='2800'
  />

  <GridItem
    name='Villa De Lago'
    imageUrl='https://www.thefinestretreats.com/images/US/Nevada/VilladeLago/1.jpg'
    locationText='Nevada, US'
    price='1950'
  />


  <GridItem
      name='Cave House'
      imageUrl='https://cf.bstatic.com/xdata/images/hotel/max1024x768/260837048.jpg?k=ec0ca216f75a379a8ef151c3c7ecab15db44acd0e1d624e0cda16ba7f7b13b6a&o=&hp=1'
      locationText='South Aegean, Greece'
      price='1880'
    />
  </Grid>
  )
}


function ColorSchemeToggle() {
  const { mode, setMode } = useColorScheme();
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  if (!mounted) {
    return <IconButton size='sm' variant='outlined' color='primary' />;
  }
  return (
    <IconButton
      id='toggle-mode'
      size='sm'
      variant='outlined'
      color='primary'
      onClick={() => {
        if (mode === 'light') {
          setMode('dark');
        } else {
          setMode('light');
        }
      }}
    >
      {mode === 'light' ? <DarkModeRoundedIcon /> : <LightModeRoundedIcon />}
    </IconButton>
  );
}

export default function App() {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  return (
    <CssVarsProvider disableTransitionOnChange theme={teamTheme}>
      <CssBaseline />
      {drawerOpen && (
        <Layout.SideDrawer onClose={() => setDrawerOpen(false)}>
          <VerticalNavbar />
        </Layout.SideDrawer>
      )}
      <Layout.Root
        sx={{
          ...(drawerOpen && {
            height: '100vh',
            overflow: 'hidden',
          }),
        }}
      >
        <Layout.Header>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 1.5,
            }}
          >
            <IconButton
              variant='outlined'
              size='sm'
              onClick={() => setDrawerOpen(true)}
              sx={{ display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <IconButton
              size='sm'
              variant='solid'
              sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
            >
              <HotelIcon />
            </IconButton>
            <Typography component='h1' fontWeight='xl'>
              Travel Haven
            </Typography>
          </Box>
          <Input
            size='sm'
            placeholder='Search…'
            startDecorator={<SearchRoundedIcon color='primary' />}
            sx={{
              flexBasis: '500px',
              display: {
                xs: 'none',
                sm: 'flex',
              },
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1.5 }}>
            <IconButton
              size='sm'
              variant='outlined'
              color='primary'
              sx={{ display: { xs: 'inline-flex', sm: 'none' } }}
            >
              <SearchRoundedIcon />
            </IconButton>
            <IconButton
              size='sm'
              variant='outlined'
              color='primary'
              component='a'
              href='/settings'
            >
              <SettingsIcon />
            </IconButton>
            <ColorSchemeToggle />
          </Box>
        </Layout.Header>
        <Layout.SideNav>
          <VerticalNavbar />
        </Layout.SideNav>

        <Layout.Main>
          <ViewGrid>

          </ViewGrid>
        </Layout.Main>
                           
      </Layout.Root>

    </CssVarsProvider>
  );
}